import { axiosInstance } from './api';
import type { Paginated } from './types';

export interface AreaDto {
  id: string;
  direction_vectors?: number[][];
  type: string;
  camera: string;
  name?: string;
}

export interface AreaCreateDto {
  direction_vectors: number[][];
  camera: string;
  name?: string;
}

export interface AreaPatchDto {
  direction_vectors?: number[][];
  name?: string;
  camera?: string;
}

export const listAreasByCamera = (cameraId: string, pageSize = 1000) => {
  return axiosInstance.get<Paginated<AreaDto>>(`/core/api/areas/?camera=${cameraId}&page_size=${pageSize}`);
};

export const listAllAreas = (pageSize = 5000) => {
  return axiosInstance.get<Paginated<AreaDto>>(`/core/api/areas/?page_size=${pageSize}`);
};

export const listAreasByZone = (zoneId: string, pageSize = 5000) => {
  return axiosInstance.get<Paginated<AreaDto>>(`/core/api/areas/?camera__zone=${zoneId}&page_size=${pageSize}`);
};

export const createArea = (payload: AreaCreateDto) => {
  return axiosInstance.post<AreaDto>('/core/api/areas/', payload);
};

export const patchArea = (areaId: string, payload: AreaPatchDto) => {
  return axiosInstance.patch<AreaDto>(`/core/api/areas/${areaId}/`, payload);
};

export const deleteArea = (areaId: string) => {
  return axiosInstance.delete(`/core/api/areas/${areaId}/`);
};
